var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoAmazonDarkBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 152,
    height: 46,
    viewBox: "0 0 152 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 119.164,
    height: 36,
    fill: "#242e45"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Custom_Size_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 152,
    height: 46
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Custom_Size_1",
    "data-name": "Custom Size \\u2013 1",
    clipPath: "url(#clip-Custom_Size_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-amazon",
    transform: "translate(15.418 10)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-amazon-2",
    "data-name": "logo-amazon",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(0.125 0.125)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Amazon_logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8",
    d: "M68.3,20.542c-6.91,5.093-16.926,7.811-25.55,7.811a46.235,46.235,0,0,1-31.213-11.91c-.647-.585-.067-1.382.709-.927A62.828,62.828,0,0,0,43.471,23.8a62.1,62.1,0,0,0,23.821-4.871c1.17-.5,2.148.766,1,1.615",
    transform: "translate(5.475 7.481)",
    fill: "#242e45",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path10",
    d: "M54.39,17.662c-.88-1.128-5.839-.533-8.065-.269-.678.083-.782-.507-.171-.932,3.949-2.78,10.43-1.977,11.186-1.046s-.2,7.433-3.908,10.534c-.569.476-1.113.223-.859-.409.833-2.081,2.7-6.745,1.817-7.878",
    transform: "translate(22.254 7.075)",
    fill: "#242e45",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path12",
    d: "M46.467,3.74v-2.7a.667.667,0,0,1,.683-.683h12.1a.673.673,0,0,1,.7.683V3.352a3.807,3.807,0,0,1-.911,1.7L52.767,14a13.359,13.359,0,0,1,6.9,1.48,1.231,1.231,0,0,1,.642,1.051v2.883c0,.393-.435.854-.891.616a13.935,13.935,0,0,0-12.78.021c-.419.228-.859-.228-.859-.621V16.691a3.267,3.267,0,0,1,.445-1.858L53.486,4.419h-6.32a.669.669,0,0,1-.7-.678",
    transform: "translate(22.267 0.173)",
    fill: "#242e45",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14",
    d: "M17.975,20.713h-3.68a.7.7,0,0,1-.657-.626V1.2A.691.691,0,0,1,14.346.52h3.432a.693.693,0,0,1,.668.632V3.621h.067a4.858,4.858,0,0,1,4.845-3.5c2.3,0,3.742,1.113,4.778,3.5a5.435,5.435,0,0,1,9.343-1.434c1.165,1.589.927,3.9.927,5.922L38.4,20.029a.7.7,0,0,1-.709.683H34.016a.7.7,0,0,1-.663-.683V10.019a23.644,23.644,0,0,0-.1-3.541,1.917,1.917,0,0,0-2.164-1.625,2.444,2.444,0,0,0-2.2,1.548,11.434,11.434,0,0,0-.342,3.618V20.03a.7.7,0,0,1-.709.683H24.16a.7.7,0,0,1-.663-.683l0-10.011c0-2.107.347-5.207-2.267-5.207-2.645,0-2.542,3.023-2.542,5.207V20.03a.7.7,0,0,1-.709.683",
    transform: "translate(6.633 0.059)",
    fill: "#242e45",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    d: "M65.027.122c5.461,0,8.417,4.69,8.417,10.653,0,5.761-3.266,10.332-8.417,10.332-5.362,0-8.282-4.69-8.282-10.534C56.745,4.692,59.7.122,65.027.122m.031,3.856c-2.712,0-2.883,3.7-2.883,6s-.036,7.236,2.852,7.236c2.852,0,2.987-3.975,2.987-6.4a17.463,17.463,0,0,0-.549-5.011,2.3,2.3,0,0,0-2.407-1.827",
    transform: "translate(27.601 0.059)",
    fill: "#242e45",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    d: "M74.161,20.713H70.5a.7.7,0,0,1-.663-.683L69.828,1.136a.7.7,0,0,1,.709-.616h3.411a.7.7,0,0,1,.657.528V3.937h.067C75.7,1.354,77.147.122,79.689.122a4.828,4.828,0,0,1,4.3,2.226c.963,1.511.963,4.053.963,5.88v11.89a.707.707,0,0,1-.709.6H80.548a.7.7,0,0,1-.652-.6V9.858c0-2.065.238-5.088-2.3-5.088a2.4,2.4,0,0,0-2.127,1.511,8.359,8.359,0,0,0-.585,3.577V20.03a.708.708,0,0,1-.719.683",
    transform: "translate(33.965 0.059)",
    fill: "#242e45",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    d: "M43.3,11.75a7.2,7.2,0,0,1-.688,3.9,2.99,2.99,0,0,1-2.546,1.672c-1.413,0-2.241-1.077-2.241-2.666,0-3.137,2.811-3.706,5.476-3.706v.8m3.711,8.97a.768.768,0,0,1-.87.088,8.97,8.97,0,0,1-2.112-2.454c-2.019,2.06-3.453,2.676-6.067,2.676-3.1,0-5.507-1.91-5.507-5.735a6.246,6.246,0,0,1,3.924-6.015c2-.88,4.788-1.035,6.921-1.279V7.526a4.693,4.693,0,0,0-.45-2.666A2.45,2.45,0,0,0,40.788,3.9a2.8,2.8,0,0,0-2.956,2.21.77.77,0,0,1-.642.673L33.624,6.4a.649.649,0,0,1-.549-.771C33.893,1.3,37.806,0,41.305,0a8.344,8.344,0,0,1,5.544,1.832c1.791,1.672,1.62,3.9,1.62,6.33V13.9a5.033,5.033,0,0,0,1.387,3.411.7.7,0,0,1-.016.978c-.751.626-2.086,1.791-2.821,2.443l-.005-.01",
    transform: "translate(15.788)",
    fill: "#242e45",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path30",
    d: "M10.844,11.75a7.2,7.2,0,0,1-.688,3.9,2.984,2.984,0,0,1-2.547,1.672c-1.413,0-2.236-1.077-2.236-2.666,0-3.137,2.811-3.706,5.471-3.706v.8m3.711,8.97a.768.768,0,0,1-.87.088,9.062,9.062,0,0,1-2.112-2.454c-2.019,2.06-3.447,2.676-6.067,2.676C2.412,21.031,0,19.121,0,15.3A6.253,6.253,0,0,1,3.924,9.281c2-.88,4.788-1.035,6.92-1.278V7.526A4.733,4.733,0,0,0,10.4,4.861,2.462,2.462,0,0,0,8.333,3.9a2.805,2.805,0,0,0-2.961,2.21.77.77,0,0,1-.637.673L1.164,6.4a.652.652,0,0,1-.549-.771C1.439,1.3,5.347,0,8.846,0A8.344,8.344,0,0,1,14.39,1.832c1.791,1.672,1.62,3.9,1.62,6.33V13.9A5.033,5.033,0,0,0,17.4,17.309a.691.691,0,0,1-.01.978c-.751.626-2.086,1.791-2.821,2.443l-.01-.01",
    fill: "#242e45",
    fillRule: "evenodd"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAmazonDarkBlue);
export default __webpack_public_path__ + "static/media/logo-amazon-dark-blue.738bd9fe47126b661a50333591db397e.svg";
export { ForwardRef as ReactComponent };